import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';

export function isMessagingEnabled(): boolean {
	return !isFedRamp();
}
